import styled from "styled-components";
export const ID_EDITOR_CONTENTS = "editor-contents";

export const Container = styled.div.attrs({
    id: ID_EDITOR_CONTENTS,
})<{
    enableDarkTheme?: boolean;
}>`
    position: fixed;
    top: 140px;
    right: 20%;
    bottom: 100px;
    width: 60%;
    color: ${(p) => (p.enableDarkTheme ? "#fff" : "#000")};

    & > div:first-child {
        display: block;
        width: 100%;
        height: 100%;
        outline: none;
        overflow: auto;
        overflow-x: hidden;
        font-size: 19px;
        font-family: urdu;
        font-weight: 500;
        line-height: 170%;
        text-align: right;
    }

    div {
        font-weight: 500;
    }

    img {
        max-width: 100%;
    }

    blockquote {
        margin: 40px 0;
        padding: 20px;
        color: ${(p) => (p.enableDarkTheme ? "#666" : "#fff")};
        background-color: ${(p) => (p.enableDarkTheme ? "#fff" : "#666")};

        * {
            font-weight: 500;
        }
    }

    code {
        display: block;
        direction: ltr;
        margin: 40px 0;
        padding: 10px 0 10px 15px;
        border-left: 4px solid #ccc;
        width: 100%;
        font-size: 13px;
        text-align: left;
        line-height: 150%;
        color: ${(p) => (p.enableDarkTheme ? "#666" : "#666")};
        background-color: #f3f3f3;
        font-family: "Source Code Pro", monospace;
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        margin: 15px 0;
    }

    b,
    strong {
        font-weight: 700;
    }

    a {
        color: #4d8cf5;
        text-decoration: none;
    }

    ol {
        list-style: arabic-indic;
    }

    ul > li {
        list-style-type: circle;
    }

    .ltr-text {
        direction: ltr;
        font-family: Roboto, sans-serif;
    }
    .ltr-text b,
    .ltr-text strong {
        font-weight: 700;
    }

    div.ltr-text,
    span.ltr-text {
        font-size: 17px;
    }

    h1 span.ltr-text,
    h2 span.ltr-text,
    h3 span.ltr-text,
    h4 span.ltr-text,
    h5 span.ltr-text,
    h6 span.ltr-text {
        font-size: inherit;
    }

    .rtl-text {
        direction: rtl;
    }

    .__change-added {
        color: #3c763d;
        background-color: #dff0d8;
    }

    .__change-removed {
        color: #a94442;
        background-color: #f2dede;
    }
`;

export default Container;
